import * as types from "../actions/actionTypes";

const initialState = {
  letters: [],
  requesting: false,
  letterSelected: [],
  allSelected: false
};

const letterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.REQUEST_LETTERS:
      return { ...state, requesting: true };
    case types.REQUEST_LETTERS_SUCCESS:
      return { ...state, requesting: false, letters: action.letters };
    case types.APP_FLUSH_DATAS:
      return {
        ...state,
        letters: [],
        requesting: false
      };

    case types.SELECT_LETTER: {
      return {
        ...state,
        letterSelected: [...state.letterSelected, action.letterSelected]
      };
    }
    case types.UNSELECT_LETTER:
      return {
        ...state,
        letterSelected: state.letterSelected.filter(
          lSelected => action.letterUnselected.id !== lSelected.id
        ),
        allSelected: false
      };
    case types.CLEAR_SELECTED_LETTERS:
      return { ...state, letterSelected: [], allSelected: false };
    case types.SELECT_MULTIPLE_LETTER: {
      if (!action.value)
        return { ...state, letterSelected: [], allSelected: false };
      return { ...state, letterSelected: action.letters, allSelected: true };
    }
    case types.UPDATE_LETTER_STATUS: {
      let newLetterList = [];

      state.letters.forEach(letter => {
        if (
          action.letterIds.findIndex(letterId => {
            return letter.id === letterId;
          }) >= 0
        ) {
          letter.status = action.status;
        }
        newLetterList.push(letter);
      });
      return { ...state, letters: newLetterList };
    }
    default:
      return state;
  }
};

export default letterReducer;



// WEBPACK FOOTER //
// ./src/reducers/letterReducer.js